<template>
  <div class="col_2 w894 onsite_b task_kaoshi_list">
    <v-dialog/>
    <h5 class="none_ts" v-if="cntData <= 0 || !lists" style="text-align: center;">
      <img src="@/assets/images/none_data.jpg" alt="">
      <h4>暂无报名</h4>
    </h5>
    <dl v-for="item in lists" :key="item.id" style="border-bottom: 1px solid #e5e5e5; margin-bottom: 0; height:200px;">
      <dd>
        <span v-if="item.signupuserList && item.signupuserList.length>0" :class="{btn_px: item.signupuserList[0].state == '1', btn_end: item.signupuserList[0].state != '1'}">{{item.signupuserList[0].stateName}}</span>
        <img src="@/assets/images/zy_default.png" v-if="!item.cover || item.cover == ''" class="list_img" />
        <img :src="item.cover" v-if="item.cover && item.cover !== ''" class="list_img">
        <h3>{{item.name}}</h3>
        <p class="man_num"><b>{{item.userCnt}}</b>人已报名</p>
        <p class="man_num" style="top: 85px;">报名人数上限: <span v-if="item.number == '0'">不限制</span><span v-else>{{item.number}}人</span></p>
        <p class="man_num" style="top: 105px">报名时间:
          <span :class="{ 'enrroll_a': $utils.judgmentState(item.starttime, item.endtime) === '1', 'enrroll_b': $utils.judgmentState(item.starttime, item.endtime) === '0', 'enrroll_c': $utils.judgmentState(item.starttime, item.endtime) === '2' }">
                {{dateFormat(new Date(item.starttime), 'yyyy-MM-dd')}} 至 {{dateFormat(new Date(item.endtime), 'yyyy-MM-dd')}}
              </span>
        </p>
        <p class="man_num" style="top: 125px">授课时间:
          <span :class="{ 'enrroll_a': $utils.judgmentState(item.lectureStartTime, item.lectureEndTime) === '1', 'enrroll_b': $utils.judgmentState(item.lectureStartTime, item.lectureEndTime) === '0', 'enrroll_c': $utils.judgmentState(item.lectureStartTime, item.lectureEndTime) === '2' }">
                {{dateFormat(new Date(item.lectureStartTime), 'yyyy-MM-dd hh:mm')}} 至 {{dateFormat(new Date(item.lectureEndTime), 'yyyy-MM-dd hh:mm')}}
              </span>
        </p>
        <!--<p class="price_a" style="padding-top: 5px;" v-if="item.cost > 0">¥<span>{{item.cost}}</span>元</p>-->
        <p class="price_a" style="padding-top: 5px;" v-if="item.cost == 0"><span>免费</span></p>
        <p class="price_a" style="padding-top: 5px;" v-if="item.cost && item.cost > 0"><span>收费</span></p>
        <a class="go_btn" @click="goCheckEnroll(item)" style="cursor: pointer;" :style="{'right': (!item.signupuserList && $utils.judgmentState(item.starttime, item.endtime) === '0') ? '130px' : '0'}">查看详情</a>
        <a style="cursor: pointer;" @click="goEnroll(item)" class="go_btn" v-if="!item.signupuserList && $utils.judgmentState(item.starttime, item.endtime) === '0'">报名</a>
      </dd>
    </dl>
    <!--<dl v-for="item in lists" :key="item.id">
      <dt>报名开始：{{item.starttime}}  报名截止： {{item.endtime}}<span><b>{{item.userCnt}}</b>人已报名</span></dt>
      <dt v-if="item.signupuserList">
        <span v-if="item.orderid">订单编号：{{item.orderid}}</span>
        <span>
          <span v-if="item.payDate">付款日期：{{ dateFormat(new Date(item.payDate), 'yyyy-MM-dd hh:mm:ss') }}</span>
          <b>{{item.signupuserList[0].paystateName}}</b>
          <b v-if="item.signupuserList[0].state == '0'">未确认</b>
          <b v-if="item.signupuserList[0].state == '1'">已确认</b>
          <b v-if="item.signupuserList[0].state == '2'">拒绝</b>
        </span>
      </dt>
      <dd>
        <img src="@/assets/images/zy_default.png" v-if="!item.cover || item.cover == ''" class="list_img" />
        <img :src="item.cover" v-if="item.cover && item.cover !== ''" class="list_img">
        <h3>
          {{item.name}}
          <span v-if="item.type == '01'" style="display: inline-block; font-size: 14px; line-height: 14px; background: #ff3633; border-radius: 5px; color: white; padding: 5px;">线上课程</span>
          <span v-if="item.type == '02'" style="display: inline-block; font-size: 14px; line-height: 14px; background: #ff3633; border-radius: 5px; color: white; padding: 5px;">直播</span>
          <span v-if="item.type == '03'" style="display: inline-block; font-size: 14px; line-height: 14px; background: #ff3633; border-radius: 5px; color: white; padding: 5px;">计划</span>
          <span v-if="item.type == '04'" style="display: inline-block; font-size: 14px; line-height: 14px; background: #ff3633; border-radius: 5px; color: white; padding: 5px;">线下课程</span>
        </h3>
        <p class="man_num">报名人数上限: {{item.number}}人</p>
        <p class="price_a" v-if="item.cost > 0">¥<span>{{item.cost}}</span>元</p>
        <p class="price_a" v-if="item.cost == 0"><span>免费</span></p>
        <a class="go_btn" @click="goCheckEnroll(item)" style="cursor: pointer;" :style="{'right': (!item.signupuserList) ? '130px' : '0'}">查看详情</a>
        <a style="cursor: pointer;" @click="goEnroll(item)" class="go_btn" v-if="!item.signupuserList">报名</a>
        <div v-if="item.signupuserList">
          <a style="cursor: pointer; right: 130px;" @click="goCheck(item)" class="go_btn" v-if="item.type !== '04' && item.signupuserList[0].state == '1'">开始学习</a>
          <a style="cursor: pointer;" class="go_btn" v-if="item.signupuserList[0].state !== '1' && (item.signupuserList[0].paystate == '0' || item.signupuserList[0].paystate == '2')" @click="continuePay(item.signupuserList[0])">继续支付</a>
          <a style="cursor: pointer;" class="reset_btn" v-if="item.signupuserList[0].state !== '1' && (item.signupuserList[0].paystate == '0' || item.signupuserList[0].paystate == '2')" @click="cancelOrder(item.signupuserList[0])">取消订单</a>
        </div>
      </dd>
    </dl>-->
    <!--<div class="onsite_list_bottom">
      <div v-if="cntData > 0">共<b>{{cntData}}</b>条记录</div>
      <div v-if="cntData > 0">
        <paginate :click-handler="clickCallback" :page-count=pages
                  :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                  :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                  :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                  :first-last-button=$global.paginationOptions.first_last_button
                  :active-class=$global.paginationOptions.active_class
                  :disabled-class=$global.paginationOptions.disabled_class
                  :first-button-text=$global.paginationOptions.first_button_text
                  :last-button-text=$global.paginationOptions.last_button_text
                  :prev-text=$global.paginationOptions.prev_text
                  :next-text=$global.paginationOptions.next_text>
        </paginate>
      </div>
    </div>-->
    <div class="tan kcfl_add" style="display:none;">
      <div class="px_add_con" style="width: 400px; height: 300px; margin-left: -200px;">
        <div class="h250 rdiv">
          <h3>{{formRequired}}</h3>
          <a  href="javascript:void(0);"  class="close" @click="$utils.fadeOut('.kcfl_add')" ></a>
          <div style="height: 200px; padding: 5px;">
            <input type="radio" name="enroll-form-radio" class="enroll-form" value="1" checked />&nbsp;&nbsp;是&nbsp;&nbsp;
            <input type="radio" class="enroll-form enroll-form-no" name="enroll-form-radio" value="0" />&nbsp;&nbsp;否&nbsp;&nbsp;
            <textarea id="enroll-form" class="put_495 textarea_style" placeholder="请填写样机型号"></textarea>
          </div>
        </div>
        <div class="clear"></div>
        <div class="w240 wrap mt5">
          <input type="button" value="确定" class="all_btn" @click="submitForm(enrollform)" />
          <input type="button" value="取消" @click="$utils.fadeOut('.kcfl_add')" class="all_btn color_hui" style="background: #ccc;"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import Paginate from 'vuejs-paginate'
  import { getCookie } from '@/store/cookies.js'
  import utils from '@/utils'
  export default {
    components: { Paginate },
    props: {
      path: {
        type: String
      },
      formRequired: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        lists: [],
        enrollform: {},
        orgType: '',
        filters: {
          pageNo: 1,
          pageSize: 6,
          itemType: '04'
        },
        pages: 0,
        cntData: '',
        prefix: this.$route.meta.prefix || ''
      }
    },
    created () {
      this.search(this.filters)
      if (getCookie('org')) {
        this.orgType = getCookie('org').businessId || 'void'
      }
    },
    methods: {
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: () => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }
            },
            {
              title: '取消'
            }
          ]
        })
      },
      dateFormat: utils.dateFormat,
      clickCallback (pageNum) {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      search (filters) {
        api.post(config.bylApiPath, '/studyItemPermissions/myTasks', filters, (r) => {
          this.lists = r.data
          this.cntData = r.cntData // 总数
          this.pages = Math.ceil(r.cntData / this.filters.pageSize) // 页数
        })
      },
      goCheckEnroll (item) {
        var path = getCookie('org') ? this.$OR.getUrl(getCookie('org').businessId) : ''
        this.$router.push({path: path + '/enroll/'+ item.id})
      },
      goCheck (item) {
        var path = getCookie('org') ? this.$OR.getUrl(getCookie('org').businessId) : ''
        switch (item.type) {
          case '01': {
            this.$router.push({path: path + '/courseDetail/'+ item.businessId})
            break
          }
          case '02': {
            this.$router.push({path: path + '/livePlay/'+ item.businessId})
            break
          }
          case '03': {
            this.$router.push({path: path + '/plan/'+ item.businessId})
            break
          }
          case '04': {
            this.$router.push({path: path + '/courseDetail/'+ item.businessId})
            break
          }
        }
      },
      openForm (item) {
        this.$utils.fadeIn('.kcfl_add')
      },
      submitForm (item) {
        let v = $('input:radio[name=enroll-form-radio]:checked').val()
        var _submit = () => {
          item.remarks = v + '|' + $('#enroll-form').val()
          this.$utils.fadeOut('.kcfl_add')
          this.goPay(item)
        }
        if (v == '1') { // 选择了“是”
          if (!$('#enroll-form').val()) {
            this.$toasted.show('请填写样机型号')
          } else {
            _submit()
          }
        } else {
          _submit()
        }
      },
      goEnroll (item) {
        this.enrollform = item
        if (this.formRequired) {
          if ((parseInt(item.number) >0) && (parseInt(item.userCnt) >= parseInt(item.number))) {
            this.$toasted.show('对不起, 报名人数已满')
          } else {
            this.openForm(item)
          }
        } else {
          this.goPay(item)
        }
      },
      goPay (item) {
        var that = this
        if (getCookie(process.env.TOKEN_KEY)) {
          if ((parseInt(item.number) >0) && (parseInt(item.userCnt) >= parseInt(item.number))) {
            this.$toasted.show('对不起, 报名人数已满')
          } else {
            this.$api.post(this.$global.enrollApiPath, '/signupuser/search', {pageNo: 1, pageSize: 12, signupid: item.id}, r => {
              var state = !!(r.data) // 该报名是否已创建过报名记录（无论是否付费或确认）
              var _addEnroll = function () {
                that.confirmBox({
                  title: '报名',
                  text: '确认报名吗？',
                  yes: function () {
                    that.$api.post(that.$global.enrollApiPath, '/signupuser/save', { // 生成报名记录
                      signupid: item.id,
                      payState: '0'
                    }, r => {
                      if (r.data) {
                        if (item.cost > 0) { // 不免费才需要购买, 跳转至支付页面
                          that.$router.push({path: that.prefix + '/enrollPay/' + item.id + '/' + '1' + '/' + r.data.id + '/' + that.orgType + '/' + encodeURIComponent(window.location.href) + '/' + r.data.sign})
                        } else { // 免费报名成功
                          that.$modal.hide('dialog')
                          that.$toasted.show('报名成功')
                          that.search(that.filters)
                        }
                      }  else {
                        that.$toasted.show('系统繁忙, 请稍后再试')
                      }
                    })
                  }
                })
              }
              if (state) { //
                if (r.data && r.data[0]) {
                  var s = r.data[0].state
                  if (s == '1') { // 已确认
                    this.$toasted.show('您已报名')
                  } else if (s == '0') { // 未确认的话需要先删除掉原来记录
                    var payState = null // 获取当前支付状态paystate
                    if (r.data && r.data[0].paystate) {
                      payState = r.data[0].paystate
                    } else { // 没有支付状态
                      payState = '2'
                    }
                    var sid = r.data[0].id
                    if (payState == '2') { // 重新报名
                      that.$api.post(that.$global.paymentApiPath, '/paycenter/orderCancel', {businessId: sid}, r => {
                        that.$api.get(that.$global.enrollApiPath, '/signupuser/delete', { // 删除报名记录
                          id: sid
                        }, r => {
                          _addEnroll()
                        })
                      }, e => {
                        if (e=='PAY_ERROR_00014') { // 支付成功了，刷新页面
                          that.search(that.filters)
                        }
                      })
                    } else if (payState == '0') { // 生成了订单但未完成支付
                      that.$modal.show('dialog', {
                        title: '支付',
                        text: '该报名存在未完成支付订单，是否继续支付？',
                        buttons: [
                          {
                            title: '继续',
                            default: true,
                            handler: () => {
                              that.$api.post(that.$global.paymentApiPath, '/paycenter/orderCancel', {businessId: sid}, r => {
                                that.$api.get(that.$global.enrollApiPath, '/signupuser/delete', {id: sid}, r => {
                                  that.$api.post(that.$global.enrollApiPath, '/signupuser/save', { // 生成报名记录
                                    signupid: item.id,
                                    payState: '0'
                                  }, r => {
                                    if (r.data) {
                                      if (item.cost > 0) { // 不免费才需要购买, 跳转至支付页面
                                        that.$router.push({path: that.prefix + '/enrollPay/' + item.id + '/' + '1' + '/' + r.data.id + '/' + that.orgType + '/' + encodeURIComponent(window.location.href) + '/' + r.data.sign})
                                      } else { // 免费报名成功
                                        that.$modal.hide('dialog')
                                        that.$toasted.show('报名成功')
                                        that.search(that.filters)
                                      }
                                    }  else {
                                      that.$toasted.show('系统繁忙, 请稍后再试')
                                    }
                                  })
                                }, e => {
                                  that.$toasted.show(e.message, {
                                    duration: 800
                                  })
                                })
                              }, e => {
                                if (e == 'PAY_ERROR_00014') {
                                  that.search(that.filters)
                                }
                              })
                            }
                          },
                          {
                            title: '取消订单',
                            handler: () => {
                              that.$api.post(that.$global.paymentApiPath, '/paycenter/orderCancel', {businessId: sid}, r => {
                                that.$api.get(that.$global.enrollApiPath, '/signupuser/delete', {id: sid}, r => {
                                  that.$modal.hide('dialog')
                                  that.$toasted.show('订单取消成功！', {
                                    duration: 800
                                  })
                                  that.search(that.filters)
                                }, e => {
                                  that.$toasted.show(e.message, {
                                    duration: 800
                                  })
                                })
                              }, e => {
                                if (e == 'PAY_ERROR_00014') {
                                  that.search(that.filters)
                                }
                              })
                            }
                          }
                        ]
                      })
                    }
                  }
                }
              } else { // 没有创建过报名，第一次报名
                _addEnroll()
              }
            })
          }
        } else {
          this.$toasted.show('请先登录')
        }
      },
      continuePay (item) {
        var that = this
        that.confirmBox({
          title: '继续支付',
          text: '确认继续吗？',
          yes: function () {
            var _addEnroll = function () {
              that.$api.post(that.$global.enrollApiPath, '/signupuser/save', { // 生成报名记录
                signupid: item.signupid,
                payState: '0'
              }, r => {
                if (r.data) {
                  if (item.cost > 0) { // 不免费才需要购买, 跳转至支付页面
                    that.$router.push({path: that.prefix + '/enrollPay/' + item.signupid + '/' + '1' + '/' + r.data.id + '/' + that.orgType + '/' + encodeURIComponent(window.location.href) + '/' + r.data.sign})
                  } else { // 免费报名成功
                    that.$modal.hide('dialog')
                    that.$toasted.show('报名成功')
                    that.search(that.filters)
                  }
                }  else {
                  that.$toasted.show('系统繁忙, 请稍后再试')
                }
              })
            }
            that.$api.post(that.$global.paymentApiPath, '/paycenter/orderCancel', {businessId: item.id}, r => {
              that.$api.get(that.$global.enrollApiPath, '/signupuser/delete', {id: item.id}, r => {
                _addEnroll()
              }, e => {
                that.$toasted.show(e.message, {
                  duration: 800
                })
              })
            }, e => {
              if (e == 'PAY_ERROR_00014') {
                that.search(that.filters)
              }
            })
          }
        })
      },
      cancelOrder (item) {
        var that = this
        that.confirmBox({
          title: '取消订单',
          text: '确认取消吗？',
          yes: function () {
            that.$api.post(that.$global.paymentApiPath, '/paycenter/orderCancel', {businessId: item.businessId}, r => {
              that.$api.get(that.$global.enrollApiPath, '/signupuser/delete', {id: item.id}, r => {
                that.$modal.hide('dialog')
                that.$toasted.show('订单取消成功！', {
                  duration: 800
                })
                that.search(that.filters)
              }, e => {
                that.$toasted.show(e.message, {
                  duration: 800
                })
              })
            }, e => {
              if (e == 'PAY_ERROR_00014') {
                that.search(that.filters)
              }
            })
          }
        })
      }
    }
  }
</script>

<style scoped>
  .task_kaoshi_list dl dd > span {
    width: auto;
    height: 30px;
    line-height: 30px;
    text-align: center;
    position: absolute;
    top: 34px;
    left: 0;
    color: #fff;
    display: block;
    z-index: 1;
    padding: 0 5px;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
  }
  .task_kaoshi_list dl dd > span.btn_end {
    background: #24282e;
  }
  .task_kaoshi_list dl dd > span.btn_px {
    background: rgb(255, 54, 51);
  }
</style>



// WEBPACK FOOTER //
// src/page/modules/task/myEnroll.vue